import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { memo, useCallback, useContext, } from 'react';
import { preventDefault } from 'shared/hooks/utils';
import { DeviceUISettingsContent } from 'console/shared/contexts/device-ui-settings/types';
import { HideIndicator } from '../../indicators/hide';
import * as S from './styles';
export const HidingElement = memo(function HidingElement(props) {
    const { children, show, hide } = props;
    const { sorting_mode } = useContext(DeviceUISettingsContent);
    const onClick = useCallback((e) => {
        preventDefault(e);
        if (sorting_mode) {
            hide();
        }
    }, [sorting_mode, hide]);
    return (_jsxs(Box, { position: "relative", sx: {
            '&.sortable-chosen.sortable-ghost': {
                opacity: 0.2,
            },
        }, height: "100%", onClick: onClick, children: [sorting_mode && _jsx(HideIndicator, { show: show }), _jsx(S.HidingComponent, { show: show, sorting_mode: sorting_mode, children: children })] }));
});
